import Control from '../Control';
import classnames from 'classnames';

import Fragment from '../inspector/Fragment';
import Inspector from '../inspector/Inspector';

const SelectControl = wp.components.SelectControl;

export default class Spacing extends Control {
  /**
   * Add custom attribute for mobile visibility
   *
   * @param {Object} settings Settings for the block
   *
   * @return {Object} Modified settings
   */
  registerBlockType(settings) {
    settings.attributes = Object.assign(settings.attributes, {
      SpacingControl_padding_space: {
        type: 'string',
        default: '',
      },
      SpacingControl_padding_side: {
        type: 'string',
        default: '',
      },
      SpacingControl_margin_space: {
        type: 'string',
        default: '',
      },
      SpacingControl_margin_side: {
        type: 'string',
        default: '',
      },
    });

    return settings;
  }

  /**
   * Add mobile visibility controls as Block Panel
   *
   * @param {function} Block Block edit component
   *
   * @return {function} Modified block edit component
   */
  BlockEdit(Block, props) {
    const { attributes, setAttributes } = props;

    const {
      SpacingControl_padding_space,
      SpacingControl_padding_side,
      SpacingControl_margin_space,
      SpacingControl_margin_side,
    } = attributes;

    const options_space = [
      {
        label: 'Default',
        value: '',
      },
      {
        label: 'None',
        value: '0',
      },
      {
        label: 'Small',
        value: 'sm',
      },
      {
        label: 'Medium',
        value: 'md',
      },
      {
        label: 'Large',
        value: 'lg',
      },
      {
        label: 'Extra-large',
        value: 'xl',
      },
    ];

    const options_side = [
      {
        label: 'All',
        value: '',
      },
      {
        label: 'Horizontal',
        value: 'x',
      },
      {
        label: 'Vertical',
        value: 'y',
      },
      {
        label: 'Top',
        value: 't',
      },
      {
        label: 'Bottom',
        value: 'b',
      },
      {
        label: 'Left',
        value: 'l',
      },
      {
        label: 'Right',
        value: 'r',
      },
    ];

    return (
      <Fragment>
        <Block {...props} />
        <Inspector>
          <Inspector.Body
            title={this.options.label || 'Spacing'}
            initialOpen={false}
          >
            <Inspector.Row>
              <div>
                <p>
                  <strong>Padding</strong>
                </p>

                <SelectControl
                  label={'Space'}
                  value={SpacingControl_padding_space}
                  onChange={val =>
                    setAttributes({
                      SpacingControl_padding_space: val,
                    })
                  }
                  options={options_space}
                />

                <SelectControl
                  label={'Side'}
                  value={SpacingControl_padding_side}
                  onChange={val =>
                    setAttributes({
                      SpacingControl_padding_side: val,
                    })
                  }
                  options={options_side}
                />
              </div>
            </Inspector.Row>
            <Inspector.Row>
              <div>
                <p>
                  <strong>Margin</strong>
                </p>

                <SelectControl
                  label={'Space'}
                  value={SpacingControl_margin_space}
                  onChange={val =>
                    setAttributes({
                      SpacingControl_margin_space: val,
                    })
                  }
                  options={options_space}
                />

                <SelectControl
                  label={'Side'}
                  value={SpacingControl_margin_side}
                  onChange={val =>
                    setAttributes({
                      SpacingControl_margin_side: val,
                    })
                  }
                  options={options_side}
                />
              </div>
            </Inspector.Row>
          </Inspector.Body>
        </Inspector>
      </Fragment>
    );
  }

  /**
   * Add custom element class on save element
   *
   * @param {Object} props Block element
   * @param {Object} blockType Blocks object
   * @param {Object} attributes Blocks attributes
   *
   * @return {Object} Modified block element.
   */
  extraProps(props, blockType, attributes) {
    const {
      SpacingControl_padding_space,
      SpacingControl_padding_side,
      SpacingControl_margin_space,
      SpacingControl_margin_side,
    } = attributes;

    if (
      typeof SpacingControl_padding_space !== 'undefined' &&
      SpacingControl_padding_space != ''
    ) {
      let padding_class =
        'p' + SpacingControl_padding_side + '-' + SpacingControl_padding_space;

      props.className = classnames(props.className, padding_class);
    }

    if (
      typeof SpacingControl_margin_space !== 'undefined' &&
      SpacingControl_margin_space != ''
    ) {
      let margin_class =
        'm' + SpacingControl_margin_side + '-' + SpacingControl_margin_space;

      props.className = classnames(props.className, margin_class);
    }

    return props;
  }
}
